const SCROLL_BOTTOM_THRESHOLD = 4

// Перерахувати розміри SimpleBar (він тримає інстанси у WeakMap, не на element.SimpleBar).
// Потрібно, коли дропдаун ініціалізувався прихованим (display:none) і відкрився пізніше.
function recalcSimpleBar(el) {
    try {
        const sb = (window.SimpleBar && SimpleBar.instances && SimpleBar.instances.get(el)) || el.SimpleBar
        if (sb && typeof sb.recalculate === 'function') sb.recalculate()
    } catch (e) {}
}

const SCROLL_HINT_SVG = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 5L16 10L21 5" stroke="#595959" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9 10L16 16L23 10" stroke="#595959" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

class PPC {

    constructor(el) {
        this.el = el
        this.type = el.dataset.type

        this.variantsBox = el.querySelector('.ppc__variants')
        this.subSelect = el.querySelector('.ppc__subproducts')

        this.qtyInput = el.querySelector('.ppc__qty-input')
        this.priceBox = el.querySelector('.ppc__price')
        this.oldPriceBox = el.querySelector('.ppc__price-old')

        this.form = el.querySelector('.ppc__form')
        this.buyButton = el.querySelector('.ppc__buy')
        this.fieldId           = el.querySelector('[name=id]')
        this.fieldVariantTitle = el.querySelector('[name=variant_title]')
        this.fieldPrice        = el.querySelector('[name=price]')
        this.fieldCompare      = el.querySelector('[name=compare_at_price]')
        this.fieldQty          = el.querySelector('[name=quantity]')

        this.currentVariants = []
        this.currentVariant = null
        this._closeHandler = null

        this.init()
    }

    init() {

        if (this.type === 'simple') {
            this.initSimple()
        }

        else if (this.type === 'subproducts') {
            this.initSubproductSelect()
            this.loadFromActiveSubproduct()
        }

        else {
            this.currentVariants = this.normalizeVariants(
                JSON.parse(this.el.dataset.variants || "[]")
            )
            this.renderVariants()
        }

        this.initQuantity()
        this.initMobilePurchaseDock()
    }

    formatPrice(price) {
        return `$${(price / 100).toFixed(2)}`
    }

    normalizeVariants(list = []) {
        return list.map(v => ({
            id: String(v.id),
            title: v.title,
            price: Number(v.price),
            compare_at_price: Number(v.compare_at_price || 0)
        }))
    }

    initSimple() {

        const variants = this.normalizeVariants(
            JSON.parse(this.el.dataset.variants || "[]")
        )

        if (!variants.length) return

        const v = variants[0]

        this.currentVariant = v

        if (this.variantsBox) {
            this.variantsBox.remove()
        }

        this.sync()
    }

    initSubproductSelect() {

        const wrap = this.subSelect
        if (!wrap) return

        const toggle = wrap.querySelector('.ppc__select-toggle')
        const dropdown = wrap.querySelector('.ppc__select-dropdown')
        if (!toggle || !dropdown) return

        if (!dropdown.SimpleBar) {
            new SimpleBar(dropdown, { autoHide: false })
            this._subScrollCheck = this.attachScrollHint(dropdown)
        }

        toggle.onclick = () => {
            wrap.classList.toggle('is-open')
            if (wrap.classList.contains('is-open')) {
                // SimpleBar ініціалізувався, коли дропдаун був display:none (розміри = 0).
                // Без перерахунку при відкритті контент має нульову висоту → тач-скрол
                // не працює, а скролбар невидимий. recalculate() дає правильні розміри.
                recalcSimpleBar(dropdown)
                this.scrollSelectIntoView(wrap)
                if (this._subScrollCheck) requestAnimationFrame(this._subScrollCheck)
            }
        }

        dropdown.onclick = (e) => {

            const item = e.target.closest('.ppc__select-option')
            if (!item) return

            dropdown.querySelectorAll('.ppc__select-option')
                .forEach(i => i.classList.remove('is-active'))

            item.classList.add('is-active')

            this.setToggleFromItem(toggle, item)

            wrap.classList.remove('is-open')

            this.loadFromActiveSubproduct()
        }

        document.addEventListener('click', (e) => {
            if (!wrap.contains(e.target)) {
                wrap.classList.remove('is-open')
            }
        })
    }

    scrollSelectIntoView(select) {
        window.requestAnimationFrame(() => {
            const dropdown = select.querySelector('.ppc__select-dropdown')
            if (!dropdown) return
            const rect = dropdown.getBoundingClientRect()
            if (rect.bottom > window.innerHeight - 16 || rect.top < 0) {
                dropdown.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
            }
        })
    }

    attachScrollHint(dropdown) {

        const items = dropdown.querySelectorAll('.ppc__select-option')
        const threshold = window.innerWidth <= 768 ? 6 : 8

        if (items.length <= threshold) {
            dropdown.style.maxHeight = 'none'
            return null
        }

        const hint = document.createElement('div')
        hint.className = 'ppc__scroll-hint'
        hint.innerHTML = SCROLL_HINT_SVG
        dropdown.appendChild(hint)

        const scroller = dropdown.querySelector('.simplebar-content-wrapper')
        if (!scroller) return null

        const check = () => {
            const atBottom = scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight < SCROLL_BOTTOM_THRESHOLD
            hint.classList.toggle('is-hidden', atBottom)
        }

        scroller.addEventListener('scroll', check, { passive: true })
        return check
    }

    setToggleFromItem(toggle, item) {

        const title = item.querySelector('.ppc__select-title')?.textContent || item.textContent
        const price = item.querySelector('.ppc__select-price')?.innerHTML || ''

        toggle.innerHTML = `
            <span class="ppc__select-copy">
                <span class="ppc__select-title">${title}</span>
            </span>
            ${price ? `<span class="ppc__select-price">${price}</span>` : ''}
        `
    }

    loadFromActiveSubproduct() {

        const active = this.subSelect?.querySelector('.is-active')
        if (!active) return

        const toggle = this.subSelect.querySelector('.ppc__select-toggle')
        if (toggle) {
            this.setToggleFromItem(toggle, active)
        }

        this.currentVariants = this.normalizeVariants(
            JSON.parse(active.dataset.variants || "[]")
        )

        this.resetQty()
        this.renderVariants()
    }

    renderVariants() {

        if (!this.currentVariants.length || !this.variantsBox) return

        if (this.type === 'variants') {
            this.renderVariantSelect()
            return
        }

        this.variantsBox.innerHTML = ''

        const frag = document.createDocumentFragment()

        this.currentVariants.forEach((v, i) => {

            const btn = document.createElement('button')
            btn.type = 'button'
            btn.className = 'ppc__variant'

            btn.textContent = v.title

            btn.dataset.id = v.id
            btn.dataset.price = v.price
            btn.dataset.title = v.title
            btn.dataset.compare = v.compare_at_price

            if (i === 0) {
                btn.classList.add('is-active')
                this.currentVariant = v
            }

            frag.appendChild(btn)
        })

        this.variantsBox.appendChild(frag)

        this.sync()
    }

    renderVariantSelect() {

        this.variantsBox.innerHTML = ''

        const wrap = document.createElement('div')
        wrap.className = 'ppc__select'

        const toggle = document.createElement('div')
        toggle.className = 'ppc__select-toggle'

        const dropdown = document.createElement('div')
        dropdown.className = 'ppc__select-dropdown'
        dropdown.setAttribute('data-simplebar', '')

        this.currentVariants.forEach((v, i) => {

            const item = document.createElement('div')
            item.className = 'ppc__select-option'

            item.innerHTML = `
                <span class="ppc__select-title">${v.title}</span>
                <span class="ppc__select-price">${this.formatPrice(v.price)}</span>
            `

            item.dataset.id = v.id
            item.dataset.price = v.price
            item.dataset.title = v.title
            item.dataset.compare = v.compare_at_price

            if (i === 0) {
                item.classList.add('is-active')
                this.setToggleFromItem(toggle, item)
                this.currentVariant = v
            }

            dropdown.appendChild(item)
        })

        wrap.appendChild(toggle)
        wrap.appendChild(dropdown)
        new SimpleBar(dropdown, { autoHide: false })
        const checkHint = this.attachScrollHint(dropdown)
        this.variantsBox.appendChild(wrap)

        this.sync()

        toggle.onclick = () => {
            wrap.classList.toggle('is-open')
            if (wrap.classList.contains('is-open')) {
                recalcSimpleBar(dropdown)
                this.scrollSelectIntoView(wrap)
                if (checkHint) requestAnimationFrame(checkHint)
            }
        }

        dropdown.onclick = (e) => {

            const item = e.target.closest('.ppc__select-option')
            if (!item) return

            dropdown.querySelectorAll('.ppc__select-option')
                .forEach(i => i.classList.remove('is-active'))

            item.classList.add('is-active')

            this.setToggleFromItem(toggle, item)

            this.currentVariant = {
                id: item.dataset.id,
                title: item.dataset.title,
                price: Number(item.dataset.price),
                compare_at_price: Number(item.dataset.compare || 0)
            }

            wrap.classList.remove('is-open')

            this.resetQty()
            this.sync()
        }

        if (this._closeHandler) document.removeEventListener('click', this._closeHandler)
        this._closeHandler = (e) => {
            if (!wrap.contains(e.target)) wrap.classList.remove('is-open')
        }
        document.addEventListener('click', this._closeHandler)
    }

    selectVariant(btn) {

        this.variantsBox.querySelectorAll('.ppc__variant')
            .forEach(b => b.classList.remove('is-active'))

        btn.classList.add('is-active')

        this.currentVariant = {
            id: String(btn.dataset.id),
            title: btn.dataset.title,
            price: Number(btn.dataset.price),
            compare_at_price: Number(btn.dataset.compare || 0)
        }

        const togglePrice = this.type === 'variants'
            ? this.el.querySelector('.ppc__select-toggle .ppc__select-price')
            : null

        if (togglePrice) {
            togglePrice.textContent = this.formatPrice(btn.dataset.price)
        }

        this.resetQty()
        this.sync()
    }

    resetQty() {
        if (this.qtyInput) this.qtyInput.value = 1
        if (this.fieldQty) this.fieldQty.value = 1
    }

    initQuantity() {

        this.el.addEventListener('click', e => {

            const plus = e.target.closest('.ppc__qty-btn--plus')
            const minus = e.target.closest('.ppc__qty-btn--minus')

            if (!plus && !minus) return
            if (!this.qtyInput || !this.fieldQty) return

            let val = parseInt(this.qtyInput.value) || 1

            if (plus) val++
            if (minus) val--

            if (val < 1) val = 1

            this.qtyInput.value = val
            this.fieldQty.value = val

            this.updatePrice()
        })
    }

    updatePrice() {

        if (!this.currentVariant) return

        const qty = parseInt(this.qtyInput?.value) || 1

        const price = Number(this.currentVariant.price)
        const compare = Number(this.currentVariant.compare_at_price)

        if (this.priceBox) this.priceBox.textContent = this.formatPrice(price * qty)

        if (this.oldPriceBox) {
            if (compare > price) {
                this.oldPriceBox.textContent = this.formatPrice(compare * qty)
            } else {
                this.oldPriceBox.textContent = ''
            }
        }

        if (this.mobileDockPrice) {
            this.mobileDockPrice.textContent = this.priceBox.textContent
        }
    }

    initMobilePurchaseDock() {

        if (!this.form || !this.buyButton) return

        const dock = document.createElement('div')
        dock.className = 'ppc__mobile-dock'
        dock.setAttribute('aria-hidden', 'true')

        const price = document.createElement('span')
        price.className = 'ppc__mobile-dock-price'
        price.textContent = this.priceBox?.textContent || ''

        const button = document.createElement('button')
        button.type = 'button'
        button.className = 'add_to_cart_button ppc__mobile-dock-buy btn btn-primary'
        button.textContent = this.buyButton.textContent.trim()

        dock.append(price, button)
        this.form.appendChild(dock)

        this.mobileDock = dock
        this.mobileDockPrice = price

        let frame = null
        const update = () => {
            if (frame) return
            frame = window.requestAnimationFrame(() => {
                frame = null
                this.updateMobilePurchaseDock()
            })
        }

        this._mobileDockUpdate = update

        window.addEventListener('scroll', update, { passive: true })
        window.addEventListener('resize', update, { passive: true })
        window.visualViewport?.addEventListener('resize', update, { passive: true })
        window.visualViewport?.addEventListener('scroll', update, { passive: true })
        this.el.addEventListener('click', update)

        update()
    }

    updateMobilePurchaseDock() {

        if (!this.mobileDock || !this.buyButton) return

        if (window.innerWidth > 768) {
            this.mobileDock.classList.remove('is-visible')
            this.mobileDock.setAttribute('aria-hidden', 'true')
            return
        }

        const viewport = window.visualViewport
        const visibleTop = viewport?.offsetTop || 0
        const visibleHeight = viewport?.height || window.innerHeight
        const visibleBottom = visibleTop + visibleHeight
        const obscuredBottom = viewport
            ? Math.max(0, window.innerHeight - visibleBottom)
            : 0

        const cardRect = this.el.getBoundingClientRect()
        const buttonRect = this.buyButton.getBoundingClientRect()
        const dropdownOpen = Boolean(this.el.querySelector('.ppc__select.is-open'))
        const cardVisible = cardRect.bottom > visibleTop && cardRect.top < visibleBottom
        const buttonBelowViewport = buttonRect.bottom > visibleBottom - 12
            && buttonRect.top > visibleTop
        const buttonFullyVisible = buttonRect.top >= visibleTop + 12
            && buttonRect.bottom <= visibleBottom - 12
        const shouldShow = cardVisible
            && buttonBelowViewport
            && !buttonFullyVisible
            && !dropdownOpen

        this.mobileDock.style.setProperty('--ppc-visual-bottom', `${obscuredBottom}px`)
        this.mobileDock.classList.toggle('is-visible', shouldShow)
        this.mobileDock.setAttribute('aria-hidden', shouldShow ? 'false' : 'true')
    }

    sync() {

        if (!this.currentVariant) return

        const { id, title, price, compare_at_price } = this.currentVariant

        if (this.fieldId)           this.fieldId.value           = id
        if (this.fieldVariantTitle) this.fieldVariantTitle.value = title
        if (this.fieldPrice)        this.fieldPrice.value        = price
        if (this.fieldCompare)      this.fieldCompare.value      = compare_at_price || ''

        this.updatePrice()
    }

}

document.querySelectorAll('.ppc').forEach(el => {

    try {
        const instance = new PPC(el)

        el.addEventListener('click', e => {

            const variant = e.target.closest('.ppc__variant')
            if (variant) instance.selectVariant(variant)

        })
    } catch (error) {
        console.error('[PPC] card init failed:', el.dataset.type || 'unknown', error)
    }

})

// Аналітика вибору на сторінці товару (Q3): чи юзають дропдаун пакета, вибір варіанта, к-сть.
// Делегування на document — переживає ре-рендери PPC. Дзеркалить мікро-воронку картки:
// pdp_option_dropdown_open -> pdp_option_select -> pdp_variant_select -> add_to_cart_pdp.
document.addEventListener('click', e => {
    if (!e.target.closest('.ppc')) return
    let name = null
    if (e.target.closest('.ppc__subproducts .ppc__select-toggle')) name = 'pdp_option_dropdown_open'
    else if (e.target.closest('.ppc__subproducts .ppc__select-option')) name = 'pdp_option_select'
    else if (e.target.closest('.ppc__variant') || e.target.closest('.ppc__variants .ppc__select-option')) name = 'pdp_variant_select'
    else if (e.target.closest('.ppc__qty-btn--plus, .ppc__qty-btn--minus')) name = 'pdp_qty_stepper'
    if (name && typeof window.psTrack === 'function') window.psTrack(name)
})
